import moment from 'moment-timezone'

export const addGroupedApptTypes = (appointmentTypes) => {
  const apptTypeDropdown = appointmentTypes.slice()
  const newPatientAppointments = {
    id: 'new',
    description: 'New Patient Bookings',
  }
  const existingPatientAppointments = {
    id: 'existing',
    description: 'Existing Patient Bookings',
  }
  apptTypeDropdown.unshift(newPatientAppointments, existingPatientAppointments)
  return apptTypeDropdown
}

export const selectedApptTypeArr = (appointmentTypes, selectedApptType) => {
  const visibilities = ['new', 'existing']
  if (visibilities.includes(selectedApptType)) {
    const appointmentTypeIds = []
    appointmentTypes.forEach((apptType) => {
      if (apptType.visibility === selectedApptType) {
        appointmentTypeIds.push(apptType.id)
      }
    })
    return appointmentTypeIds
  }
  return [selectedApptType]
}

export function parseEvents(bookings) {
  if (!bookings || !bookings.length) {
    return null
  }

  const events = bookings.slice()

  // create a sorted array of all the start and end events
  const times = events.reduce((acc, event) => {
    event.renderLength = event.length > 30 ? event.length : 30
    event.start = moment(event.start_datetime)
    event.end = moment(event.start_datetime).add(event.length, 'm')
    // type property marks if an event is a starting or ending time, 0 for start, 1 for end
    return acc.concat([{ e: event, time: event.start, type: 0 }, { e: event, time: event.end, type: 1 }])
  }, [])
  // sort by time, if time of two events is equal, start event goes first
  .sort((a, b) => {
    if (!a.time.isSame(b.time, 'minute')) {
      return a.time.diff(b.time)
    }
    if (a.type !== b.type) {
      return b.type - a.type
    }
    return b.e.end.diff(a.e.end)
  })
  // group events to calculate their widths and offset:
  let curGroup = []
  let eventsRunning = 0
  let maxCol = 0
  for (let i = 0; i < times.length; i++) {
    if (!times[i].type) {
      curGroup.push(times[i].e)
      eventsRunning++
      if (eventsRunning > maxCol) {
        maxCol = eventsRunning
      }
    } else {
      eventsRunning--
    }
    if (eventsRunning === 0) {
      const columns = []
      curGroup.forEach((event) => {
        event.numCols = maxCol
        for (let i = 0; i < maxCol; i++) {
          if (!columns[i] || columns[i].end <= event.start) {
            columns[i] = event
            event.colIndex = i
            break
          }
        }
      })
      maxCol = 0
      curGroup = []
    }
  }
  return events
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/helpers.js